const React = require('react');
const PropTypes = require('prop-types');
import { FormattedText } from 'core/i18n';

class OlderContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div
                ref="ageDiv"
                className={this.props.hiddenOlderContainer ? 'hidden' : 'age-restriction'}
                id={this.props.id}
            >
                <div className="prospects-gutter prospects-separator">
                    <div className="row">
                        <div className="col-xs-12">
                            <i className="icons icons--icon-plus-eighteen"></i>
                            <h5 className="font-heading5 age-restriction__title">
                                <FormattedText value="initial-thankYouInterested" />
                            </h5>
                            <span className="dash"></span>
                            <p className="font-paragraph2 age-restriction__description">
                                <FormattedText value="initial-sorryMessage" />
                            </p>
                            <div>
                                <i className="icons icons--icon-phone-blue"></i>
                                <p className="font-paragraph2 age-restriction__call-center">
                                    <FormattedText value="initial-contactMessage" />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form__footer form__footer-inner">
                    <div className="text-right">
                        <button
                            type="button"
                            className="form__button form__button-secondary"
                            onClick={this.props.handleOnClick}
                        >
                            <FormattedText value="button-understood" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

OlderContainer.propTypes = {
    hiddenOlderContainer: PropTypes.bool,
    handleOnClick: PropTypes.func,
};

module.exports = OlderContainer;
